import React, { useState } from 'react';
import QuestionCardNew from './QuestionCardNew';
import { useParams } from 'react-router-dom';
import { trackQuizCompleted, trackLessonCompleted } from '../../../lib/analytics';
import { getVideoLessonProgress } from '../../../lib/videoLessonApi';
import css from './QuizDesign/quizDesign.module.css';

const QuestionCardExample = ({ onActivityComplete, questions, lessonId: propLessonId, videoLessonId: propVideoLessonId }) => {
    const { id } = useParams();
    const activeLessonId = propLessonId || (id ? parseInt(id, 10) : null);
    // URL param 'id' is always the correct VideoLesson ID (e.g. 24 for /lesson/24)
    // lesson.id might be a UserVideoLesson progress ID, lesson.video.id is a Video file ID
    // So for the questions API, always prefer the URL param
    const activeVideoLessonId = id ? parseInt(id, 10) : (propVideoLessonId || activeLessonId);
    
    const [finalScore, setFinalScore] = React.useState(0);
    const [showIntro, setShowIntro] = useState(true);
    
    const questionCount = questions?.length || 10;
    
    const handleTestComplete = async (results) => {
        console.log('Test completed!', results);
        
        const lessonId = activeLessonId;
        const score = results.percentage || 0;
        
        setFinalScore(Math.round(score / 10));
        
        if (lessonId) {
            trackQuizCompleted(lessonId, score);
            
            const progress = await getVideoLessonProgress(lessonId);
            if (progress?.completion_status === 'COMPLETED') {
                trackLessonCompleted(lessonId);
            }
        }
    };

    if (showIntro) {
        return (
            <div className={css.quizWrap}>
                <div className={css.introScreen}>
                    {/* Icon */}
                    <div className={css.introIcon}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"/>
                            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                            <path d="M12 17h.01"/>
                        </svg>
                    </div>

                    {/* Title & Description */}
                    <h2 className={css.introTitle}>Перевірте розуміння</h2>
                    <p className={css.introDesc}>
                        Пройдіть короткий тест із {questionCount} питань, щоб перевірити, що ви запам'ятали з відео.
                    </p>

                    {/* Stats */}
                    <div className={css.introStats}>
                        <div className={css.introStat}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
                            {questionCount} питань
                        </div>
                        <div className={css.introStat}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
                            3 типи завдань
                        </div>
                        <div className={css.introStat}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                            3–5 хвилин
                        </div>
                    </div>

                    {/* Test Types */}
                    <div className={css.introTypesLabel}>Що буде в тесті</div>
                    <div className={css.introTypes}>
                        <div className={css.introType}>
                            <span className={`${css.introTypeBadge} ${css.badgeTF}`}>True / False</span>
                            <p>Визначте, чи твердження правильне.</p>
                            <div className={css.introExample}>"Anna lives in Warsaw."</div>
                        </div>
                        <div className={css.introType}>
                            <span className={`${css.introTypeBadge} ${css.badgeWM}`}>Word meaning</span>
                            <p>Оберіть правильний переклад слова.</p>
                            <div className={css.introExample}>"from" означає "з" чи "бо"</div>
                        </div>
                        <div className={css.introType}>
                            <span className={`${css.introTypeBadge} ${css.badgeFB}`}>Fill in the blank</span>
                            <p>Доповніть речення правильним словом із запропонованих варіантів.</p>
                            <div className={css.introExample}>"My ___ is Anna."</div>
                        </div>
                    </div>

                    {/* Start Button */}
                    <button className={css.introBtn} onClick={() => setShowIntro(false)}>
                        Почати тест <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                    </button>
                    <div className={css.introNote}>Тест містить різні типи завдань і займе кілька хвилин.</div>
                </div>
            </div>
        );
    }

    return (
        <div>
            {activeVideoLessonId ? (
                <QuestionCardNew
                    videoLessonId={activeVideoLessonId}
                    initialQuestions={questions}
                    onTestComplete={handleTestComplete}
                    onActivityComplete={(score) => {
                        setFinalScore(score);
                        if (onActivityComplete) onActivityComplete(score);
                    }}
                    maxAttempts={2}
                    enabledTestTypes={{
                        yesNo: true,
                        textVoice: true,
                        dragDrop: false,
                        translationMatch: true
                    }}
                />
            ) : (
                <div>No video lesson ID provided</div>
            )}
        </div>
    );
};

export default QuestionCardExample;